import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "brand" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = { class: "nav-label" }
const _hoisted_5 = { class: "nav-label" }
const _hoisted_6 = { class: "nav-label" }
const _hoisted_7 = { class: "nav-label" }
const _hoisted_8 = { class: "nav-label" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "nav-label" }
const _hoisted_11 = { class: "nav-label" }
const _hoisted_12 = { class: "sidebar-footer" }
const _hoisted_13 = { class: "avatar" }
const _hoisted_14 = { class: "nav-label" }
const _hoisted_15 = { class: "topbar" }
const _hoisted_16 = {
  key: 0,
  class: "global-search-results"
}
const _hoisted_17 = {
  key: 0,
  class: "global-search-empty"
}
const _hoisted_18 = {
  key: 1,
  class: "global-search-empty"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 2,
  class: "global-search-empty"
}
const _hoisted_24 = { class: "top-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")
  const _component_RouterView = _resolveComponent("RouterView")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["crm-shell", { dark: $setup.dark }])
  }, [
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { open: $setup.mobileMenu, expanded: $setup.sidebarExpanded }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "brand-mark" }, "A", -1 /* CACHED */)),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "nav-label" }, "Affiliate CRM", -1 /* CACHED */)),
        _createElementVNode("button", {
          class: "sidebar-toggle",
          title: $setup.sidebarExpanded ? 'Свернуть меню' : 'Развернуть меню',
          onClick: $setup.toggleSidebar
        }, _toDisplayString($setup.sidebarExpanded ? '‹' : '›'), 9 /* TEXT, PROPS */, _hoisted_2)
      ]),
      _createElementVNode("nav", {
        onClick: _cache[0] || (_cache[0] = $event => ($setup.mobileMenu = false))
      }, [
        _createVNode(_component_RouterLink, {
          to: "/dashboard",
          title: $setup.messages[$setup.locale].dashboard
        }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "▦", -1 /* CACHED */)),
            _createElementVNode("b", _hoisted_3, _toDisplayString($setup.messages[$setup.locale].dashboard), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createVNode(_component_RouterLink, {
          to: "/partners",
          title: $setup.messages[$setup.locale].partners
        }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "♙", -1 /* CACHED */)),
            _createElementVNode("b", _hoisted_4, _toDisplayString($setup.messages[$setup.locale].partners), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createVNode(_component_RouterLink, {
          to: "/tasks",
          title: $setup.messages[$setup.locale].tasks
        }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "✓", -1 /* CACHED */)),
            _createElementVNode("b", _hoisted_5, _toDisplayString($setup.messages[$setup.locale].tasks), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createVNode(_component_RouterLink, {
          to: "/reports",
          title: $setup.messages[$setup.locale].reports
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "↗", -1 /* CACHED */)),
            _createElementVNode("b", _hoisted_6, _toDisplayString($setup.messages[$setup.locale].reports), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createVNode(_component_RouterLink, {
          to: "/imports",
          title: $setup.messages[$setup.locale].imports
        }, {
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "⇄", -1 /* CACHED */)),
            _createElementVNode("b", _hoisted_7, _toDisplayString($setup.messages[$setup.locale].imports), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createVNode(_component_RouterLink, {
          to: "/chats",
          title: $setup.messages[$setup.locale].chats
        }, {
          default: _withCtx(() => [
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "✦", -1 /* CACHED */)),
            _createElementVNode("b", _hoisted_8, _toDisplayString($setup.messages[$setup.locale].chats), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        ($setup.me?.role === 'admin')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "/rails_pulse",
              title: $setup.messages[$setup.locale].monitoring
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "⌁", -1 /* CACHED */)),
              _createElementVNode("b", _hoisted_10, _toDisplayString($setup.messages[$setup.locale].monitoring), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_9))
          : _createCommentVNode("v-if", true),
        ($setup.me?.role === 'admin')
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 1,
              to: "/settings",
              title: $setup.messages[$setup.locale].settings
            }, {
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "⚙", -1 /* CACHED */)),
                _createElementVNode("b", _hoisted_11, _toDisplayString($setup.messages[$setup.locale].settings), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString($setup.me?.name?.slice(0, 1) || "?"), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("strong", null, _toDisplayString($setup.me?.name), 1 /* TEXT */),
          _createElementVNode("small", null, _toDisplayString($setup.me?.role), 1 /* TEXT */)
        ])
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["workspace", { 'sidebar-expanded': $setup.sidebarExpanded }])
    }, [
      _createElementVNode("header", _hoisted_15, [
        _createElementVNode("button", {
          class: "icon-button mobile-only",
          onClick: _cache[1] || (_cache[1] = $event => ($setup.mobileMenu = !$setup.mobileMenu))
        }, "☰"),
        _createElementVNode("div", {
          class: _normalizeClass(["top-search global-search", {active:$setup.searchOpen}])
        }, [
          _cache[16] || (_cache[16] = _createTextVNode("⌕ ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.search) = $event)),
            placeholder: "Поиск партнёров и задач…",
            onFocus: _cache[3] || (_cache[3] = $event => ($setup.searchOpen=true)),
            onKeydown: $setup.searchKeyboard
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelText, $setup.search]
          ]),
          ($setup.searchOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                ($setup.search.length < 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Введите минимум 2 символа"))
                  : ($setup.searchLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Ищем…"))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        ($setup.groupedResults.partners.length)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                              _createElementVNode("header", null, [
                                _cache[14] || (_cache[14] = _createTextVNode("Партнёры ", -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString($setup.groupedResults.partners.length), 1 /* TEXT */)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedResults.partners, (item) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: `partner-${item.id}`,
                                  onClick: $event => ($setup.openResult(item))
                                }, [
                                  _createElementVNode("strong", null, _toDisplayString(item.title), 1 /* TEXT */),
                                  _createElementVNode("small", null, _toDisplayString(item.subtitle || 'Без категории'), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_20))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.groupedResults.tasks.length)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                              _createElementVNode("header", null, [
                                _cache[15] || (_cache[15] = _createTextVNode("Задачи ", -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString($setup.groupedResults.tasks.length), 1 /* TEXT */)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedResults.tasks, (item) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: `task-${item.id}`,
                                  onClick: $event => ($setup.openResult(item))
                                }, [
                                  _createElementVNode("strong", null, _toDisplayString(item.title), 1 /* TEXT */),
                                  _createElementVNode("small", null, _toDisplayString(item.subtitle), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_22))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        (!$setup.groupedResults.partners.length && !$setup.groupedResults.tasks.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Ничего не найдено"))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: $setup.toggleTheme
          }, _toDisplayString($setup.dark ? "☀" : "☾"), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("main", null, [
        _createVNode(_component_RouterView)
      ])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}